export const Constants = {
    TOKEN: 'token',
    USERID: 'userid',
    LANGUAGE: 'lang',
    CREDENTIALS: 'credentials',
    URLS: 'urls'
}
